import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-fluid p-component p-formgrid p-grid p-input-filled" }
const _hoisted_2 = { class: "p-field p-col-6" }
const _hoisted_3 = { for: "name" }
const _hoisted_4 = {
  key: 0,
  class: "p-error"
}
const _hoisted_5 = {
  key: 1,
  class: "p-error"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "p-field p-col-6" }
const _hoisted_8 = { for: "description" }
const _hoisted_9 = {
  key: 0,
  class: "p-error"
}
const _hoisted_10 = {
  key: 0,
  class: "p-field p-col-12 p-d-flex p-ai-center"
}
const _hoisted_11 = {
  for: "llmExtraction",
  class: "p-ml-2 p-mb-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_DexInputText = _resolveComponent("DexInputText")!
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.Name')) + " *", 1),
      _createVNode(_component_InputText, {
        id: "name",
        modelValue: _ctx.v$.name.$model,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.name.$model) = $event)),
        class: _normalizeClass({'p-invalid':_ctx.v$.name.$invalid && _ctx.showErrorMessage}),
        onChange: _ctx.update,
        required: "true",
        autofocus: ""
      }, null, 8, ["modelValue", "class", "onChange"]),
      (_ctx.v$.name.required.$invalid && _ctx.showErrorMessage && !_ctx.v$.name.technicalValidation.$invalid)
        ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.DocumentClasses.Name')})), 1))
        : _createCommentVNode("", true),
      (_ctx.v$.name.technicalValidation.$invalid && _ctx.showErrorMessage)
        ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(_ctx.$t('Forms.Val.OnlyAllowAlphaNumericUnderscore', { field: _ctx.$t('Squeeze.DocumentClasses.Name')})), 1))
        : (!!_ctx.value.id)
          ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(_ctx.$t('Squeeze.Admin.WarnRename')), 1))
          : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.Description')) + " *", 1),
      _createVNode(_component_DexInputText, {
        id: "description",
        modelValue: _ctx.v$.description.$model,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.description.$model) = $event)),
        translatedDescription: _ctx.value.translatedDescription,
        translationKey: _ctx.value.translationKey,
        class: _normalizeClass({'p-invalid':_ctx.v$.description.$invalid && _ctx.showErrorMessage}),
        onChange: _ctx.update,
        required: "true"
      }, null, 8, ["modelValue", "translatedDescription", "translationKey", "class", "onChange"]),
      ((_ctx.v$.description.$invalid && _ctx.showErrorMessage))
        ? (_openBlock(), _createElementBlock("small", _hoisted_9, _toDisplayString(_ctx.$t('Forms.Val.MissingRequired', { field: _ctx.$t('Squeeze.DocumentClasses.Description')})), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.store.state.featureSet.llmExtraction)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_Checkbox, {
            id: "llmExtraction",
            modelValue: _ctx.llmActiveLocal,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.llmActiveLocal) = $event)),
            binary: true,
            onChange: _ctx.onChangeLlmActive
          }, null, 8, ["modelValue", "onChange"]),
          _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.LLMActive')), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}